<template>
  <div class="cadfm-container-horizontal">
    
    <RequestTable v-show="$route.params.view == 'RequestTable'" :lang="lang.RequestManager.RequestTable">
    </RequestTable>
    <RequestNew v-if="$route.params.view == 'RequestNew'" :lang="lang.RequestManager.RequestNew"></RequestNew>
    <RequestDetails v-if="$route.params.view == 'RequestDetails'" :lang="lang.RequestManager.RequestDetails">
    </RequestDetails>
    
  </div>
</template>

<script>
//import RequestRouting from '@/components/RequestManager/Views/RequestRouting'
import RequestTable from '@/components/RequestManager/Views/RequestTable'
import RequestNew from '@/components/RequestManager/Views/RequestNew'
import RequestDetails from '@/components/RequestManager/Views/RequestDetails'


//import Left from '@/components/PartManager/Left/Left'
//import Right from '@/components/PartManager/Right/Right'
//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'RequestManager',
  components: {
    //RequestRouting,
    RequestTable,
    RequestNew,
    RequestDetails,
    
  },
  props: {
    lang: Object
  },
  data () {
    return {
      sectionPrefix: "rm",
      basicView: "RequestTable",
    }
  },
  computed: {
    
    
  },
  beforeCreate () {
    
    
    this.$store.dispatch("setView", "RequestTable");
  },
  created() {
    this.$store.dispatch("showLoader", { visible: false, text: "" });
    this.$store.dispatch("setSectionPrefix", this.sectionPrefix)
  },
  methods: {
    
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RequestManager/RequestManager.vue